module.exports = __webpack_public_path__ + "static/media/浙商证券@2x.ad135592.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/浙商证券@2x.png
// module id = 1543
// module chunks = 0